import { Name } from '../auth';

export const getFullName = (name?: Name): string => {
  if (!name) return '';

  return [name.first, name.last].filter(Boolean).join(' ');
};
